// Importing from 'moment-hijri' returns a Moment instance already patched with Hijri support
import moment from 'moment-hijri';

// Patch the same instance with Jalaali (Shamsi) support as well
import 'moment-jalaali';

// Export configured moment instance
export default moment;

/**
 * Format date in Shamsi/Jalaali calendar
 * @param {Date|string} date - Date to format 
 * @param {boolean} isRTL - RTL language flag
 * @returns {string} Formatted Shamsi date
 */
export const formatShamsiDate = (date, isRTL = false) => {
  try {
    const m = moment(date);
    if (!m.isValid()) return '-';
    
    // Attempt to use moment-jalaali
    try {
      const formatStr = isRTL ? 'jYYYY/jMM/jDD' : 'jDD/jMM/jYYYY';
      const result = m.format(formatStr);
      
      // Check if the format actually worked - if not, it would return the format string itself
      if (result.includes('j')) {
        // Fallback to Gregorian if format didn't apply correctly
        return formatGregorianDate(date, isRTL);
      }
      
      return result;
    } catch (err) {
      console.warn('Error using jalaali format:', err);
      return formatGregorianDate(date, isRTL);
    }
  } catch (error) {
    console.error('Error formatting Shamsi date:', error);
    return formatGregorianDate(date, isRTL);
  }
};

/**
 * Format date in Hijri/Islamic calendar
 * @param {Date|string} date - Date to format 
 * @param {boolean} isRTL - RTL language flag
 * @returns {string} Formatted Hijri date
 */
export const formatHijriDate = (date, isRTL = false) => {
  try {
    const m = moment(date);
    if (!m.isValid()) return '-';
    
    // Attempt to use moment-hijri
    try {
      const formatStr = isRTL ? 'iYYYY/iMM/iDD' : 'iDD/iMM/iYYYY';
      const result = m.format(formatStr);
      
      // If plugin failed, `result` will still contain pattern tokens like 'iYYYY'
      if (/(iY|iM|iD)/.test(result)) {
        // Fallback to Gregorian
        return formatGregorianDate(date, isRTL);
      }
      
      return result;
    } catch (err) {
      console.warn('Error using hijri format:', err);
      return formatGregorianDate(date, isRTL);
    }
  } catch (error) {
    console.error('Error formatting Hijri date:', error);
    return formatGregorianDate(date, isRTL);
  }
};

/**
 * Format date in Gregorian calendar
 * @param {Date|string} date - Date to format 
 * @param {boolean} isRTL - RTL language flag
 * @returns {string} Formatted Gregorian date
 */
export const formatGregorianDate = (date, isRTL = false) => {
  try {
    const m = moment(date);
    if (!m.isValid()) return '-';
    
    if (isRTL) {
      return m.format('YYYY/MM/DD');
    } else {
      return m.format('DD/MM/YYYY');
    }
  } catch (error) {
    console.error('Error formatting Gregorian date:', error);
    try {
      // Last resort fallback
      const d = new Date(date);
      return d.toISOString().split('T')[0];
    } catch (e) {
      return '-';
    }
  }
}; 